import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import LightImg from '../../../assets/img/illustrations/auth-basic-login-mask-light.png';
import DarkImg from '../../../assets/img/illustrations/auth-basic-login-mask-dark.png';
import './index.scss';

const LoginIllustrations: React.FC = () => {
  const { theme } = useContext(AuthContext);
  const imgSrc = theme === 'dark' ? DarkImg : LightImg;

  return (
    <img 
      src={imgSrc} 
      alt="Login illustration" 
      className="auth-illustration"
    />
  );
};

export default LoginIllustrations;
